export default __webpack_public_path__ + "static/media/bg.c6b13fb2.webp";